<script lang="ts" setup>
import FaqArticle from '~/components/FAQ/FaqArticle.vue';
import faqModelJSON from '~/../assets/faq_models/materials.json';
const content = faqModelJSON as unknown as FAQMenuContent[];
</script>
<template>
  <FaqArticle type="materials" :content="content" router-articles="MaterialsArticles" />
</template>
